import { useMsal } from "@azure/msal-react";
import { CommandBar, ICommandBarItemProps, IDropdownOption, MessageBar, MessageBarType, Spinner, SpinnerSize, Toggle, useTheme } from "@fluentui/react";
import { RouterParams } from 'App';
import { RootState } from 'app/store';
import PageLoading from 'global/PageLoading';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import SimpleCard, { ECardIcon } from "../../components/controls/SimpleCard";
import {
    fetch_account_snapshots_Action,
    loadSnapshotAction,
    updatePharmacyInformationAction
} from "../../global/Application/dataActions";
import { AppDataSource } from "../../global/DataSources/AppDataSource";
import { MsalTokenSource } from "../../global/DataSources/MsalTokenSource";
import { bcbs_groupconfigurationsnapshot } from "../../model/AttributeOptionSets.type";
import * as IXrmTypes from "../../model/CRM";
import { IBenefit, IPharmacyORE, TGuid } from "../../model/FlexibleAttributeModel";

import { Stack } from '@fluentui/react/lib/Stack';
import { saveAs } from 'file-saver';
import { emitCustomEvent, fadeIn } from 'global/Application';
import { useAuthentication } from "../../global/Authentication";
import PlanDesign from "./PlanDesign";
import { setProcessing } from "global/Reducer/statusSlice";
import EditorNavbar from "components/layout/EditorNavbar";

interface IProps {
}


const PharmacyLanding = (props: IProps) => {
    const history = useHistory();
    const state = useSelector((state: RootState) => state);
    const { id, snapshot1, snapshot2 } = useParams<RouterParams>();
    const dispatch = useDispatch();
    const theme = useTheme();
    const authentication = useAuthentication();

    const [selectedLeftSnapshot, setSelectedLeftSnapshot] = React.useState<IDropdownOption<IXrmTypes.bcbs_groupconfigurationsnapshot>>();
    const [selectedRightSnapshot, setSelectedRightSnapshot] = React.useState<IDropdownOption<IXrmTypes.bcbs_groupconfigurationsnapshot>>();

    const { instance } = useMsal();
    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);

    const [editOpen, setEditOpen] = useState<boolean>(false);

    const saveMultiPlanDesign = (line: string, plans: TGuid[]) => {
        debugger;
        let temp = state.comp.rightSnap?.json?.pharmacyORE?.filter(p => plans?.find(q => p.id === q));
        let retArr: IPharmacyORE[] = plans.map(pl => {
            const existingPlan = temp?.find(t => t.id === pl);
            if (existingPlan) {
                return { ...existingPlan, newPharmacyPlanDesign: line };
            }
            else {
                return {
                    releaseStatus: "In Progress",
                    id: pl,
                    pharmacyPlanDesign: "",
                    newPharmacyPlanDesign: line,
                    newClientNumber: "",
                }
            }
        });
        dispatch(updatePharmacyInformationAction(dataSource, retArr));
        setEditOpen(false);

    };
    const setAllReadyForRelease = () => {
        let plans = state.comp.rightSnap?.json?.plans.filter(p => !p.deactivated);
        let temp = state.comp.rightSnap?.json?.pharmacyORE?.filter(p => plans?.find(q => p.id === q.id));
        let retArr: IPharmacyORE[] = plans.map(pl => {
            const existingPlan = temp?.find(t => t.id === pl.id);
            if (existingPlan) {
                return { ...existingPlan, releaseStatus: "Ready for Release" };
            }
            else {
                return {
                    releaseStatus: "Ready for Release",
                    id: pl.id,
                    pharmacyPlanDesign: "",
                    newPharmacyPlanDesign: "",
                    newClientNumber: "",
                }
            }
        });
        dispatch(updatePharmacyInformationAction(dataSource, retArr));
        setEditOpen(false);
    };

    if (!state)
        return null;

    if (!state.status.snapshotLoading && !state.comp.snapList.find((o) => `${o._bcbs_groupid_value?.toUpperCase()}` === id!?.toUpperCase())) {
        dispatch(fetch_account_snapshots_Action(dataSource, id!));
    }

    if (selectedLeftSnapshot && !state.status.snapshotLoading && state.comp?.leftSnap?.snapshot?.bcbs_groupconfigurationsnapshotid !== selectedLeftSnapshot.data?.bcbs_groupconfigurationsnapshotid) {
        dispatch(loadSnapshotAction(dataSource, id!, { leftSnapshot: selectedLeftSnapshot.data }));
    }

    if (selectedRightSnapshot && !state.status.snapshotLoading && state.comp?.rightSnap?.snapshot?.bcbs_groupconfigurationsnapshotid !== selectedRightSnapshot.data?.bcbs_groupconfigurationsnapshotid) {
        dispatch(loadSnapshotAction(dataSource, id!, { rightSnapshot: selectedRightSnapshot.data }));
    }


    const snapshotOptions: IDropdownOption<IXrmTypes.bcbs_groupconfigurationsnapshot>[] = state.comp.snapList.map((o) => {
        return {
            key: o.bcbs_groupconfigurationsnapshotid!,
            text: `${o.bcbs_name} -- ${bcbs_groupconfigurationsnapshot.statuscode[o.statuscode as bcbs_groupconfigurationsnapshot.Tstatuscode].name}`,
            data: o
        }
    });

    if (snapshot2 && snapshotOptions && !selectedLeftSnapshot && !state.status.snapshotLoading) {
        setSelectedLeftSnapshot(snapshotOptions.find(o => o.key === snapshot2));
    }

    if (snapshot1 && snapshotOptions && !selectedRightSnapshot && !state.status.snapshotLoading) {
        setSelectedRightSnapshot(snapshotOptions.find(o => o.key === snapshot1));
    }

    const canPharmEdit = !!(authentication.authorizations?.roles['BCBS - Power User'] || authentication.authorizations?.roles['BCBS - Pharmacy']);
    const pharmacyCategory = state.data.config.cache?.map_bcbs_config_category_named.Pharmacy;

    if (state?.comp?.rightSnap?.json?.groupCollectStatus)
        return <>
            <MessageBar className={fadeIn} messageBarType={MessageBarType.warning}>
                This snapshot was last processed with Group Collect integration, Pharmacy/ORE requires you to make a save in Group Library before you can continue.
            </MessageBar>
        </>;


    const commandBarItems: ICommandBarItemProps[] = [];

    if (authentication.authorizations?.roles['BCBS - Power User'] || authentication.authorizations?.roles['BCBS - Pharmacy']) {
        commandBarItems.push({
            key: 'pharmacy',
            text: 'Release Pharmacy/ORE',
            iconProps: { iconName: 'Send' },
            onClick: () => {
                (async function () {
                    let snapshotId = snapshot1;
                    if (!snapshotId)
                        return;

                    try {
                        dispatch(setProcessing(true))
                        const response = await dataSource.releaseRxOre(snapshotId);
                    } catch (err: any) {
                        emitCustomEvent({
                            eventType: 'globalException',
                            details: err
                        });
                        console.error(err);
                    } finally {
                        dispatch(setProcessing(false))
                    }
                })();
            }
        });

        commandBarItems.push({
            key: 'pharmacyReport',
            iconProps: { iconName: 'Generate' },
            text: 'Generate Pharmacy/ORE Extracts',
            onClick: () => {
                (async function () {
                    let snapshotId = snapshot1;
                    if (!snapshotId)
                        return;

                    try {
                        dispatch(setProcessing(true))
                        const response = await dataSource.getOptumBulkExtractReports(snapshotId);
                        saveAs(response.blob, response.fileName, { autoBom: true });
                    } catch (err: any) {
                        emitCustomEvent({
                            eventType: 'globalException',
                            details: err
                        });
                        console.error(err);
                    } finally {
                        dispatch(setProcessing(false))
                    }
                })();
            }
        });
    }

    commandBarItems.push({
        key: 'setGenerateOptumReportAsyncCall',
        iconProps: { iconName: 'Edit' },
        text: 'Set Bulk Pharmacy Plan Design',
        disabled: !canPharmEdit,
        onClick: () => setEditOpen(true)
    });

    commandBarItems.push({
        key: 'setGenerateOptumReportAsyncCall',
        iconProps: { iconName: 'Edit' },
        text: 'Set All Ready For Release',
        disabled: !canPharmEdit,
        onClick: () => setAllReadyForRelease()
    });

    const onRenderView = () => {
        return <Stack
            styles={{ root: { margin: '48px', marginTop: '10px' } }}
            horizontal
            wrap
            tokens={{ childrenGap: '15' }}
            horizontalAlign="start"
        >
            {state.comp.rightSnap?.json?.plans?.filter(p => !p.deactivated)?.map(plan => {
                const rightPharmacyBenefit: IBenefit | undefined = state.comp.rightSnap?.json?.benefits?.find(b => plan?.benefitRefs.find(b2 => b2.id === b.id) && b.bcbs_config_categoryid === pharmacyCategory.bcbs_config_categoryid);
                const rightPharmacyOre = state.comp.rightSnap?.json?.pharmacyORE?.find(p => p.id === plan.id);
                const labelText = !rightPharmacyBenefit ? "No Benefit" : rightPharmacyOre?.releaseStatus ?? "In Progress"

                const onRenderFooter = () => {
                    return (
                        <Toggle
                            label="Ready for Release?"
                            onClick={(e) => e.stopPropagation()}
                            onKeyDown={(e) => e.stopPropagation()}
                            checked={rightPharmacyOre?.releaseStatus === "Ready for Release"}
                            onChange={(e, checked) => {
                                let temp = state.comp.rightSnap?.json?.pharmacyORE?.find(p => p.id === plan?.id);
                                if (temp) {
                                    temp = { ...temp, releaseStatus: checked ? "Ready for Release" : "In Progress" };
                                } else {
                                    temp = {
                                        releaseStatus: checked ? "Ready for Release" : "In Progress",
                                        id: plan.id,
                                        pharmacyPlanDesign: "",
                                        newPharmacyPlanDesign: "",
                                        newClientNumber: ""
                                    };
                                }
                                dispatch(updatePharmacyInformationAction(dataSource, [temp]));
                            }}
                        />
                    );
                }

                return <div>
                    <SimpleCard
                        key={plan.id}
                        title={plan.name}
                        onClick={() => {
                            history.push(`/pharmacy/${id}/${snapshot1}/${plan.id}/${snapshot2 ?? ""}`)
                        }}
                        labelText={labelText}
                    />
                    {rightPharmacyBenefit && onRenderFooter()}
                </div>
            })
            }
        </Stack>

    }


    return <>
        <EditorNavbar key={"navbar"} contextMenu={{ key: 'navbar.pharmacyLanding' , items: commandBarItems}} hideShowDeactivated />
        <PlanDesign isOpen={editOpen}
            dismissPanel={() => {
                setEditOpen(false);
            }}
            bulk
            plans={state.comp.rightSnap?.json?.plans?.filter(p =>
                !p.deactivated &&
                state.comp.rightSnap?.json?.benefits?.find(b => p?.benefitRefs.find(b2 => b2.id === b.id) &&
                    b.bcbs_config_categoryid === pharmacyCategory.bcbs_config_categoryid)
            )}
            onSave={saveMultiPlanDesign}
        />
        {onRenderView()}
        {(state.status.processing || state.status.snapshotLoading) && <PageLoading />}
    </>
}

export default PharmacyLanding;
